import { faChevronDown } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useMemo, useState } from 'react'

export function CustomDropdownSelector({
  options,
  value,
  onSelect,
  label = 'Seleccione una opción*',
  getOptionLabel,
  getOptionValue,
  error,
  name = 'select',
  labelClassName = '',
  customerType = '',
}) {
  const [showOptions, setShowOptions] = useState(false)

  const selectedLabel = useMemo(() => {
    return value ? getOptionLabel(value) : label
  }, [value, getOptionLabel, label])

  const handleOptionClick = item => {
    onSelect(item)
    setShowOptions(false)
  }

  return (
    <>
      <label htmlFor={name} className={labelClassName}>
        {label}
      </label>
      <div className="no-margin-nopadding generic-address-search-filter list-prices-component flex-column">
        <button
          type="button"
          data-testid={
            name ? `btn-select-${name}-${customerType}` : 'btn-select'
          }
          className="generic-address-filter-content-list-price"
          onClick={() => setShowOptions(prev => !prev)}>
          <p className={value ? '' : 'generic-price-list-label-text-unselect'}>
            {selectedLabel}
          </p>
          <FontAwesomeIcon
            icon={faChevronDown}
            className="generic-list-price-down-icon"
          />
        </button>

        <ul
          id={name}
          className={
            showOptions
              ? 'generic-address-filter-options ul-price-list ul-filter-option-multiple'
              : 'generic-address-filter-options-hidden'
          }
          onMouseLeave={() => setShowOptions(false)}>
          {options.map((item, index) => (
            <li
              key={getOptionValue(item)}
              data-testid={
                name ? `btn-option-${name}-${index}` : `btn-option-${index}`
              }
              className="customer-filter-option-multiple"
              onClick={() => handleOptionClick(item)}>
              {getOptionLabel(item)}
            </li>
          ))}
        </ul>
      </div>
      <div className="input-feedback">{error && <strong>{error}</strong>}</div>
    </>
  )
}
